// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2hUi4","colBig":"styles_colBig__I0bIC","colSmall":"styles_colSmall__3jiss"};